export enum SignUpSteps {
    ONBOARDING = "ONBOARDING",
    DETAILS = "DETAILS",
    DESIGN = "DESIGN",
    DOWNLOAD = "DOWNLOAD",
    REDIRECTOR = "REDIRECTOR"
}

export const SignUpStepRoutes: Record<SignUpSteps, string> = {
    [SignUpSteps.ONBOARDING]: "/self-serve-onboarding",
    [SignUpSteps.DETAILS]: "/self-serve-details",
    [SignUpSteps.DESIGN]: "/self-serve-design",
    [SignUpSteps.DOWNLOAD]: "/self-serve-download",
    [SignUpSteps.REDIRECTOR]: "/app-store-redirector"
};

export const TOTAL_SIGNUP_STEPS = 4;